/**
 * Query Client Setup
 *
 * This file handles the setup and configuration of the React Query client
 * for consistent cache behavior across the application.
 */

import { QueryClient } from "react-query";
import { setQueryClientForCacheWarming } from "./cacheWarming";

export const initializeQueryClient = (queryClient: QueryClient) => {
  // Set up the query client for cache warming
  setQueryClientForCacheWarming(queryClient);
};
